import { type ComponentPropsWithRef, forwardRef } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const input = tailwindVariants({
  base: 'rounded-4 border ads:border-input border-gray-5 ads:bg-input bg-gray-1 px-2 ads:text-primary text-16 text-gray-12 outline-none focus:ads:border-primary focus:border-blue-9 focus:ads:ring-focus focus:ring-1 focus:ring-blue-9 disabled:cursor-not-allowed disabled:ads:border-input disabled:border-gray-5 disabled:ads:bg-subtle disabled:bg-gray-1 disabled:ads:text-placeholder disabled:text-gray-7',
  defaultVariants: {
    hasError: false,
    size: 'medium',
  },
  variants: {
    hasError: {
      true: 'ads:border-error border-red-9 focus:ads:border-error focus:border-red-9 focus:ads:ring-error focus:ring-red-9',
    },
    size: {
      'extra-large': 'h-12 md:text-16',
      large: 'h-10 md:text-14',
      medium: 'h-8 md:text-14',
      small: 'h-6 md:text-12',
    },
  },
});

export type InputVariants = VariantProps<typeof input>;

export type InputProps = Omit<ComponentPropsWithRef<'input'>, 'size'> &
  InputVariants & {
    htmlSize?: number;
  };

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ hasError, className, size, htmlSize, ...restOfProps }, forwardedRef) => {
    return (
      <input
        className={input({ class: className, hasError, size })}
        data-testid="INPUT"
        ref={forwardedRef}
        size={htmlSize}
        {...restOfProps}
      />
    );
  },
);

Input.displayName = 'Input';
